import React from 'react'
import Album from '../components/elements/album/Album'

function EcoleInfrasrtucturesBatiments() {
  return <Album />
}

export default EcoleInfrasrtucturesBatiments
